<template>
  <div class="report-location-map">
    <div class="map-box">
      <div id="container"></div>
      <div class="map-center-box">
        <!-- <div class="chatting">
          <van-loading size="14" v-if="getCenterLoading">加载中...</van-loading>
          <span v-else>{{mapCenterInfo.title}}</span>
        </div> -->
        <van-image
          width="50"
          height="52"
          :src="require('/src/assets/driver/location-icon.png')"
        />
      </div>
      <div class="tencent-map-footer">
        <div class="tip">
          <div class="tip-icon flex-center">
            <img :src="require('/src/assets/image/icon-assure.png')" style="width: 14px;height: 18px;" alt="">
          </div>
          定位如不准确请拖动地图进行调整
        </div>
        <div class="position" @click="handlePanToPositionPhone({ errMsgBool: true })">
          <img :src="require('/src/assets/image/position.png')" style="width: 16px;height: 16px;" alt="" v-if="positionIcon === 'position'">
          <img :src="require('/src/assets/image/position-checked.png')" style="width: 16px;height: 16px;" alt="" v-else-if="positionIcon === 'position-checked'">
          <van-loading size="16" color="#669EE6" v-else-if="positionIcon === 'loading'" />
        </div>
      </div>
    </div>
    
    <address-info 
      ref="addressInfo" 
      :mapLoaded="mapLoaded" 
      :mapCenterInfo="mapCenterInfo" 
      :getCenterLoading="getCenterLoading" 
      :queryParams.sync="queryParams" 
    />
  </div>
</template>

<script>
import { geocoder } from '@/api/dispatch/index.js';
import addressInfo from './components/address-info.vue';
import { Image , Loading  } from 'vant';
import Vconsole from 'vconsole';

export default {
  components:{ 
    addressInfo , 
    [Image.name]: Image,
    [Loading.name]: Loading,
   },
  data(){
     return {
      map:null,
      mapZoomAntiShakeTimer:null,  //地图缩放防抖计时器
      mapCenterInfo:{},  //当前地图中心数据
      getCenterLoading:false,  //获取中心点loading
      showIdentification:false,  //显示地址识别框
      //手机当前位置
      locationPhoneInfo:{
        province:'',  //省
        city:'',  //市
        district:'',  //区
        detailedAddress:'',  //详细地址
        title:'',  //标题
        latitude:'',
        longitude:'',
      },
      queryParams:{
        province:'',
        city:'',
        district:'',
        detailedAddress:'',
        phoneNumber:'',
        realName:'',
        remark:'',
        title:'',
        latitude:'',
        longitude:'',
      },
      mapLoaded:false,  //地图加载完毕(瓦片全部显示)
      mapPanendSource:'',  //地图平移操作来源
      positionIcon: "position",
    }
  },
  watch:{
    mapCenterInfo:{
      handler(val){
        let newData = this.deepClone(Object.assign(this.queryParams,val));
        newData.address = newData.detailedAddress ? newData.detailedAddress : (newData.address || "");
        this.queryParams = newData;
        return Object.assign(this.queryParams,val);
      },
      deep:true,
      immediate:true
    }
  },
  created(){
    let vConsole;
    if(process.env.NODE_ENV === 'development') {
      vConsole = new Vconsole();
      window._this = this;
    }
    // this.initData();
      if (window.plus) {
        console.log("window.plus 存在");
        this.handlePlusReady()
      } else {
        console.log("挂载plusready")
        document.addEventListener('plusready', this.handlePlusReady, false)
      }
   
  },
  mounted(){
    this.createMap()
    .then(()=>this.initMap());
  },
  beforeDestroy(){
  },
  methods:{
    async handlePlusReady(){
      console.log("handlePlusReady")
      await this.createGeolocation();
      let LatLng = {};
      let query = this.$route.query;
      if(query.latitude&&query.longitude) LatLng = { lat:query.latitude , lng:query.longitude };
      else if(query.locationPhoneLat&&query.locationPhoneLng) {
        LatLng = { lat:query.locationPhoneLat , lng:query.locationPhoneLng };
      }else LatLng = { lat: '22.543099' , lng: '114.057868' };
      if(!query.latitude || !query.longitude) {
        await this.$sleep(500);
        this.handlePanToPositionPhone().catch(() => this.getMapCenter(LatLng))
      }
    },
    async initMap(){
        if(this.map) return ;
        let query = this.$route.query;
        let LatLng = {};
        if(query.latitude&&query.longitude) LatLng = { latitude:query.latitude , longitude:query.longitude };
        else if(query.locationPhoneLat&&query.locationPhoneLng) {
          LatLng = { latitude:query.locationPhoneLat , longitude:query.locationPhoneLng };
        }else LatLng = { latitude: '22.543099' , longitude: '114.057868' };
        var center = new window.TMap.LatLng(LatLng.latitude, LatLng.longitude);
        //初始化地图
        this.map = new window.TMap.Map("container", {
            rotation: 0,//设置地图旋转角度
            pitch: 0, //设置俯仰角度（0~45）
            zoom: 17,//设置地图缩放级别
            center: center,//设置地图中心点坐标
            mapStyleId: 'style1' //设置样式ID
        });
        this.map.on('zoom',this.mapZoom);
        this.map.on('panend',this.mapPanend);
        this.map.on('dragend',this.mapDragend);
        this.map.on('tilesloaded',this.mapTilesloaded);
        await this.handleSetLocationPhoneInfo();
        
    },
    /* 设置手机当前位置信息
     * 当uni跳转过来时带了手机经纬度则根据经纬度逆地址解析设置相关信息
     * 否则需要当 plusReady 时进行相关权限校验再获取位置信息 
     */
    async handleSetLocationPhoneInfo(){
      if(!(this.$route.query.locationPhoneLat && this.$route.query.locationPhoneLng)) return Promise.resolve();
      try {
        let query = this.$route.query;
        if(query.locationPhoneLat && query.locationPhoneLng) {
          // 根据经纬度获取手机当前地址信息
          let locationPhoneResult = await this.getMapCenter({
            notSetCenterInfo:true,
            LatLng: {
              lat: query.locationPhoneLat,
              lng: query.locationPhoneLng,
            }
          })
          console.log('=========locationPhoneResult',JSON.stringify(locationPhoneResult));
          
          this.locationPhoneInfo = {
            province:locationPhoneResult.address_component.province,  //省
            city:locationPhoneResult.address_component.city,  //市
            district:locationPhoneResult.address_component.district,  //区
            detailedAddress:locationPhoneResult.pois[0].address,  //详细地址
            title:locationPhoneResult.pois[0].title,  //标题
            latitude:locationPhoneResult.location.lat,
            longitude:locationPhoneResult.location.lng,
          };
          this.mapCenterInfo = this.deepClone(this.locationPhoneInfo);
        }else {
          // 拿默认位置
          let mapCenterResult = await this.getMapCenter({
            notSetCenterInfo:true,
            LatLng: {
              lat: "22.543099",
              lng: "114.057868",
            }
          })
          this.mapCenterInfo = {
            province:mapCenterResult.address_component.province,  //省
            city:mapCenterResult.address_component.city,  //市
            district:mapCenterResult.address_component.district,  //区
            detailedAddress:mapCenterResult.pois[0].address,  //详细地址
            title:mapCenterResult.pois[0].title,  //标题
            latitude:mapCenterResult.location.lat,
            longitude:mapCenterResult.location.lng,
          };
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.resolve();
      }
    },
    // 显示修改地址的半径圆、原装货地
    // setFixAddressMap(center){
    //   //创建圆形覆盖物
    //   // let MultiCircle = new TMap.MultiCircle({ 
    //   //   map:this.map,
    //   //   styles: { // 设置圆形样式
    //   //     'circle': new TMap.CircleStyle({
    //   //       'color': 'rgba(255,139,94,0.1)',
    //   //       'showBorder': true,
    //   //       'borderColor': '#FF8B5E',
    //   //       'borderWidth': 1,
    //   //     }),
    //   //   },
    //   //   geometries: [{
    //   //     styleId: 'circle',
    //   //     center: center, //圆形中心点坐标 
    //   //     radius: 1000,	//半径（单位：米）目前限制1公里范围内
    //   //   }],
    //   // });
    //   // 创建原地址
    //   //创建并初始化MultiMarker
    //   var markerLayer = new TMap.MultiMarker({
    //     map: this.map,  //指定地图容器
    //     //样式定义
    //     styles: {
    //       //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
    //       "myStyle": new TMap.MarkerStyle({ 
    //           "width": 24,  // 点标记样式宽度（像素）
    //           "height": 24, // 点标记样式高度（像素）
    //           "src": require('@/assets/image/map-address-icon.png'),  //图片路径
    //           //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
    //           "anchor": { x: 12, y: 12 }  
    //       }) 
    //     },
    //     //点标记数据数组
    //     geometries: [{
    //       "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
    //       "styleId": 'myStyle',  //指定样式id
    //       "position": center,  //点标记坐标位置
    //     }]
    //   });
    // },
    // 地图缩放事件
    mapZoom(){
      if(this.mapZoomAntiShakeTimer){
          clearTimeout(this.mapZoomAntiShakeTimer);
          this.mapZoomAntiShakeTimer = null;
      }
      this.mapZoomAntiShakeTimer = setTimeout(()=>this.getMapCenter(),200)
    },
    // 地图拖拽交互结束时触发
    mapDragend(){
      this.getMapCenter();
      this.positionIcon = "position";
    },
    // 地图平移结束
    mapPanend(){
      switch(this.mapPanendSource) {
        case 'positionPhone':
          if(this.map.getZoom()) this.getMapCenter();
          else this.map.zoomTo(17);
          break;
        default:'';
      }
      this.mapPanendSource = '';
    },
    // 瓦片加载完毕
    mapTilesloaded(){
      this.mapLoaded = true;
      this.map.off('tilesloaded',this.mapTilesloaded);
    },
    async getMapCenter(options){
      try {
        if(!(options&&options.notSetCenterInfo)) this.getCenterLoading = true;
        let lat,lng;
        if(options&&options.LatLng) {
          lat = options.LatLng.lat;
          lng = options.LatLng.lng;
        }else {
          let centerData = this.map.getCenter();
          lat = centerData.lat;
          lng = centerData.lng;
        }
        let { result } = await geocoder({location:`${lat},${lng}`,get_poi:1,poi_options:'policy=1'});

        this.mapCenterInfo.adcode = result.ad_info.adcode;
        if(options&&options.notSetCenterInfo) return Promise.resolve(result);
        if(!result.pois.length) {
          this.mapCenterInfo = {
              province:'',  //省
              city:'',  //市
              district:'',  //区
              detailedAddress:'',  //详细地址
              title:'移动以获取位置',  //标题
              latitude:result.location.lat,
              longitude:result.location.lng,
              adcode:result.ad_info.adcode
          };
          return Promise.reject(result)
        }
        this.mapCenterInfo = {
          province:result.address_component.province,  //省
          city:result.address_component.city,  //市
          district:result.address_component.district,  //区
          detailedAddress:result.pois[0].address,  //详细地址
          title:result.pois[0].title,  //标题
          latitude:result.location.lat,
          longitude:result.location.lng,
          adcode:result.ad_info.adcode
        };
        this.getCenterLoading = false;
        return Promise.resolve(result)
      } catch (error) {
          this.getCenterLoading = false;
          return Promise.reject(error);
      }
    },
    /* 移动地图中心点至手机当前位置
     */
    async handlePanToPositionPhone(options){
      if(['loading'].includes(this.positionIcon)) return;
        try {
          this.positionIcon = "loading";
          // let PermissionResult = await permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' });
          // console.log('位置权限成功开启',JSON.stringify(PermissionResult));
          let position = await this.handleGetLocation();
          console.log("获取设备位置",JSON.stringify(position));
          if(!position.lat || !position.lng || position.lat == 5e-324 || position.lng == 5e-324 ) {
            throw new Error(position);
          };
          let { result:geocoderResult } = await geocoder({location:`${position.lat},${position.lng}`,get_poi:1,poi_options:'policy=2'});
          this.locationPhoneInfo = {
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
          };
          this.mapPanendSource = 'positionPhone';
          this.positionIcon = "position-checked";
          this.map.panTo(new window.TMap.LatLng(geocoderResult.location.lat, geocoderResult.location.lng));
          return Promise.resolve(geocoderResult);
        } catch (error) {
          console.log('位置信息获取失败',error);
          this.positionIcon = "position";
          this.listLoading = false;
          if(options && options.errMsgBool) {
            this.$dialog.confirm({
              title:'权限提示',
              message:'请在手机中开启定位信息权限',
            }).then(()=>{
              // permission.goSystemAppSetting()
              this.openAppAuthorizeSetting();
            });
          }
          return Promise.reject(error);
        }
    },
    openAppAuthorizeSetting(){
      window.uni.postMessage({
        data: { pagesType: "openAppAuthorizeSetting" }
      });
    },
    // 开启/关闭地图平移监听事件
    togglePanend(flag){
      if(flag){
        this.map.on('panend',this.mapPanend);
      }else{
        this.map.off('panend',this.mapPanend);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .mask-style {
      z-index: 9998 !important;
  } 
  ::v-deep .rotate-circle {
    display: none !important;
  }
  ::v-deep .tmap-zoom-control {
    display: none !important;
  }
  ::v-deep .tmap-scale-control {
    display: none !important;
  }
  .report-location-map {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .map-box {
      flex: 1;
      overflow: hidden;
      position: relative;
      #container {
        width: 100%;
        height: 100%;
      }
      .map-center-box {
        position: absolute;
        left: 50%;
        bottom: 50%;
        transform: translateX(-50%);
        z-index: 9;
        display: flex;
        flex-direction: column;
        align-items: center;
        .chatting {
          box-sizing: border-box;
          // background: url('/src/assets/image/chatting.png') no-repeat left top;
          min-height: 40px;
          overflow: hidden;
          background: url('../../../assets/image/chatting.png') no-repeat left top;
          background-size: 100% 100%;
          padding: 10px 10px 16px 10px;
          font-size: 14px;
          word-break: keep-all;
          text-align: center;
        }
      }
      .prompt-dialog-box {
        // height: 32px;
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 32px;
        color: #F1892E;
        background-color: #FFEAD8;
        padding-left: 20px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9997;
        // .bottom {
        //   height: 8px;
        //   position: absolute;
        //   left: 0;
        //   right: 0;
        //   bottom: -8px;
        //   z-index: 9;
        //   background-color: #FFEAD8;
        // }
      }
      .position-phone {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 10px;
        bottom: 50px;
        z-index: 3000;
        background-color: #FFF;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .van-button {
          width: 20px;
          height: 20px;
          border: 2px solid #333;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          .dot {
            width: 10px;
            height: 10px;
            background-color: #333;
            border-radius: 50%;
          }
        }
      }
      .position-phone-active {
        .van-button {
          border-color: #4776E3;
          .dot {
            background-color: #4776E3;
          }
        }
      }
      .watch-position {
        position: absolute;
        z-index: 9;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #FFF;
      }
      .tencent-map-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 8px;
        left: 12px;
        right: 12px;
        z-index: 9999;
        .tip {
          height: 32px;
          box-sizing: border-box;
          font-size: 16px;
          line-height: 28px;
          color: #12A666;
          box-shadow: 2px 2px 4px 1px rgba(8,55,35,0.16);
          background: #F2FCF4;
          border-radius: 8px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 0px 8px 0px 2px;
          font-weight: bold;
          font-family: 'DIN-Medium';
          .tip-icon {
            width: 28px;
            height: 28px;
            border-radius: 7px;
            background: linear-gradient( 180deg, #A9D58B 0%, #6AC6A2 100%);
            margin-right: 8px;
            .iconfont {
              // font-size: 18px;
              color: #FFF;
            }
          }
        }
        .position {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          box-shadow: 2px 2px 4px 1px rgba(8,55,35,0.16);
          background-color: #FFF;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          &:active {
            background-color: #F8F8F8;
          }
        }
      }
    }
    
  }
  
</style>